import * as Yup from 'yup';
import i18next from 'i18next';
import type { Maybe, AnyObject } from 'yup/lib/types';

declare module 'yup' {
  /* eslint-disable @typescript-eslint/no-unused-vars -- the three generics must mirror yup's StringSchema exactly for declaration merging to apply */
  interface StringSchema<
    TType extends Maybe<string> = string | undefined,
    TContext extends AnyObject = AnyObject,
    TOut extends TType = TType,
  > {
    /**
     * Rejects any value containing one of the given special characters (blacklist).
     * The blocked characters are injected into the translated error message via {{chars}}.
     * Empty strings pass (use `.required()` to enforce presence).
     */
    noSpecialCharacters(chars?: string): this;
  }
  /* eslint-enable @typescript-eslint/no-unused-vars */
}

let isRegistered = false;

/**
 * Registers VoPay's custom Yup string methods. Must run at module load (before any
 * validation schema is built) so the methods exist when schemas are constructed; the
 * error messages resolve lazily against the shared i18next instance at validation time.
 */
export default function registerYupMethods() {
  if (isRegistered) return;
  isRegistered = true;

  Yup.addMethod(Yup.string, 'noSpecialCharacters', function (chars = "? ! / < ~ ` ' >") {
    const escaped = chars.replace(/\s+/g, '').replace(/[.*+?^${}()|[\]\\-]/g, '\\$&');
    return this.matches(new RegExp(`^[^${escaped}]*$`), {
      excludeEmptyString: true,
      message: ({ label }) =>
        label
          ? i18next.t('components:Global.Validations.noSpecialCharactersWithLabel', { chars, label })
          : i18next.t('components:Global.Validations.noSpecialCharacters', { chars }),
    });
  });
}
